import { render } from "./비전.vue?vue&type=template&id=8b6deeba"
import script from "./비전.vue?vue&type=script&lang=js"
export * from "./비전.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__